import cx from 'classnames'
import React from 'react'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@material-ui/core'
import useStyles from './Styles'
import { Corner } from 'components/balloon'
import { Balloon } from 'components'
import { ITalentInitiatives } from './Interface'
import { isValidURL, getYoutubeId, getVimeoId } from 'utils'
import { YoutubePlayer } from 'components/youtube-player'
import { VimeoPlayer } from 'components/vimeo-player'
import { theme } from 'config/constants/theme/theme'
import CheckIcon from '@material-ui/icons/Check'

const TalentInitiatives: React.FC<ITalentInitiatives> = ({ initiatives }) => {
  const classes = useStyles({})
  const corner = Corner.BottomRight
  const bgColor = 'rgb(247, 143, 41)'

  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const getAnswerChoices = (talentChoices: string[]) => {
    return (
      <List disablePadding dense>
        {talentChoices.map((choice, idx) => (
          <ListItem dense disableGutters key={idx}>
            <ListItemIcon className={classes.questionChoiceIcon}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText className={classes.questionText}>{choice}</ListItemText>
          </ListItem>
        ))}
      </List>
    )
  }

  const getAnswerText = (talentAnswer: string | string[]) => {
    if (typeof talentAnswer === 'string')
      return <Typography className={classes.questionText}>{talentAnswer}</Typography>
    return getAnswerChoices(talentAnswer)
  }

  const getAnswerLink = (talentAnswer: string) => {
    return (
      <a
        id={`${talentAnswer}-talent-answer`}
        className={classes.questionText}
        href={talentAnswer}
        target="_blank"
        rel="noopener noreferrer"
      >
        {talentAnswer}
      </a>
    )
  }

  const getVideoPlayer = (talentAnswer: string = '') => {
    const playerSize = downMd ? { width: '100%', height: '100%' } : {}
    if (talentAnswer.includes('youtube') || talentAnswer.includes('youtu.be')) {
      return <YoutubePlayer videoId={getYoutubeId(talentAnswer)} {...playerSize} />
    }
    if (talentAnswer.includes('vimeo')) {
      return <VimeoPlayer videoId={getVimeoId(talentAnswer)} {...playerSize} />
    }
    return getAnswerLink(talentAnswer)
  }

  return (
    <Box className={classes.root}>
      {initiatives?.map((initiative: any, index: number) => (
        <Box className={classes.initiativeContainer} key={index}>
          <Typography
            id={`${index}-talent-initiative-description-label`}
            variant="h6"
            className={classes.initiativeDescription}
          >
            {initiative.description}
          </Typography>
          {initiative?.answers?.map((answer: any, index: number) => (
            <Box className={cx(classes.questionContainer, classes.questionContainerHover)} key={index}>
              <Balloon
                bgColor={bgColor}
                corner={corner}
                size={26}
                shadow={true}
                borderRadius={'50% 50% 50% 0'}
                className={classes.balloonQuestionTitle}
              >
                <QuestionAnswerIcon className={classes.balloonIcon} />
              </Balloon>
              <Box className={classes.questionTitleContainer}>
                <Typography id={`${index}-talent-initiative-question-answer`} className={classes.questionTitle}>
                  {answer.currentText}
                </Typography>
                {isValidURL(answer.talentAnswer)
                  ? getVideoPlayer(answer.talentAnswer)
                  : getAnswerText(answer.talentAnswer)}
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  )
}

TalentInitiatives.defaultProps = {
  initiatives: []
}

export default TalentInitiatives
